import { useEffect, useRef, useState } from 'react';
import { getNativeThumbnail } from './thumbnailFactory';
import { NATIVE_ASSET_MAP } from '../environment/prefabs/nativeRegistry';

/** Thumbnail for a native asset, rendered once via the shared offscreen
 *  renderer (no per-tile WebGL context). Lazy + cached. */
export default function NativeThumb({ assetId }) {
  const ref = useRef(null);
  const [src, setSrc] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(
      (e) => e.some((x) => x.isIntersecting) && setVisible(true),
      { rootMargin: '300px' }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return undefined;
    let alive = true;
    const entry = NATIVE_ASSET_MAP[assetId];
    getNativeThumbnail(assetId, entry && entry.build).then((d) => alive && setSrc(d));
    return () => {
      alive = false;
    };
  }, [visible, assetId]);

  return (
    <div ref={ref} className="w-full aspect-square flex items-center justify-center bg-gradient-to-br from-stone-800 to-stone-900 rounded-lg overflow-hidden">
      {src ? (
        <img src={src} alt="" className="w-full h-full object-contain" draggable={false} />
      ) : (
        <div className="w-6 h-6 border-2 border-amber-500/40 border-t-amber-400 rounded-full animate-spin" />
      )}
    </div>
  );
}
